import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root',
})
export class SeoService {
    public constructor(private title: Title, private meta: Meta) {}

    public setMetaTitle(title: string) {
        this.title.setTitle(title);
    }

    public setMetaDescription(description: string) {
        this.meta.updateTag({ name: 'description', content: description });
    }
}
